import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section } from "../components/LegalLayout";
import { useContent } from "../context/ContentContext";

export default function CookiePolicy() {
  const { content } = useContent();
  const COMPANY = content.company;
  return (
    <LegalLayout eyebrow="Informativa" title="Cookie Policy" updated="Agosto 2026">
      <p className="mb-8 text-[0.95rem]">
        La presente Cookie Policy descrive le tecnologie utilizzate da questo sito di {COMPANY.name},
        le finalità e le modalità di gestione, ai sensi del Provvedimento del Garante Privacy
        dell'8 maggio 2014 e delle Linee guida del 10 giugno 2021.
      </p>

      <Section n="1" title="Cosa sono i cookie">
        <p>
          I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente,
          dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
          Tecnologie analoghe (es. localStorage) consentono di archiviare informazioni nel browser.
        </p>
      </Section>

      <Section n="2" title="Cookie utilizzati da questo sito">
        <p>Questo sito utilizza esclusivamente strumenti tecnici necessari, che non richiedono il consenso preventivo:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong>Cookie/archiviazione tecnica di consenso</strong> — memorizza la scelta effettuata
            sul banner cookie, per non riproporlo ad ogni interazione.
          </li>
          <li>
            <strong>Token di sessione area riservata</strong> — utilizzato solo nell'area amministrativa
            per mantenere l'accesso autenticato.
          </li>
        </ul>
        <p>
          <strong>Non</strong> utilizziamo cookie di profilazione, di marketing o di analisi statistica
          di terze parti.
        </p>
      </Section>

      <Section n="3" title="Cookie di terze parti">
        <p>
          Il sito non installa cookie di profilazione di terze parti. Eventuali contenuti incorporati da
          piattaforme esterne (es. social network), se attivati, potrebbero installare cookie gestiti
          dai rispettivi titolari, secondo le loro informative.
        </p>
      </Section>

      <Section n="4" title="Gestione dei cookie">
        <p>
          Puoi gestire o disabilitare i cookie tramite le impostazioni del tuo browser. La
          disabilitazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito.
        </p>
      </Section>

      <Section n="5" title="Maggiori informazioni">
        <p>
          Per dettagli sul trattamento dei dati personali consulta la{" "}
          <Link to="/privacy" className="text-gold underline underline-offset-2">Privacy Policy</Link>.
          Per qualsiasi richiesta: <a href={`mailto:${COMPANY.email}`} className="text-gold underline underline-offset-2">{COMPANY.email}</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
